import React,{useState,useEffect,useRef} from 'react'
import Template from '../Components/Template'
import { useSoftDeleteExamFormMutation, useEditExamFormMutation, useGetAllExamFormsByAgentsQuery, useGetDistrictQuery, useGetTalukaByDistrictMutation, useSaveExamFormMutation } from '../Services/modules/exam';
import { Config } from '../Config';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useDataTable from '../Hooks/useDataTable';
import { MdOutlineNavigateNext, MdSkipNext, MdSkipPrevious, MdEdit, MdDelete } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import WarningModal from '../Components/WarningModal';
import { useSelector } from 'react-redux';

const marathiOnly = (val) => val.replace(/[^ऀ-ॿ\s.]/g, '');
const MARATHI_REGEX = /^[ऀ-ॿ\s.]+$/;

function Home() {
  const location = useLocation();
  const userData = useSelector((state) => state.userData.user_data);
//console.log("Usedata",userData)
  const [isSumbmiting,setIsSubmitting]=useState(false)
  const [isUpdate,setIsUpdate]=useState("")  
  const[exam_id,setExamId]=useState("")
 
  const[exam_name,setExamName]=useState("")
  const[enrollmentDate,setEnrollmentDate]=useState("")
  const[first_name,setFirstName]=useState('')
  const[middle_name,setMiddleName]=useState('')
  const[last_name,setLastName]=useState('')
const[mobile_number,setMobileNumber]=useState("")
const[student_address,setStudentAddress]=useState("")
  const[school_name,setSchoolName]=useState("")
  const[center_name,setCenterName]=useState("")
  const[school_contact_person,setSchoolContactPerson]=useState(userData.full_name)
const[school_area,setSchoolArea]=useState("")
  
  const[student_district_name,setStudentDistrictName]=useState('')
  const[student_taluka,setStudentTaluka]=useState('')
  const[student_district_id,setStudentDistrictId]=useState("")
  const[exam_standard,setExamStandard]=useState("")

  const[school_district_id,setSchoolDistrictId]=useState("")
  const[school_district_name,setSchoolDistrictName]=useState('')

  const[school_taluka,setSchoolTaluka]=useState('')
const [errors, setErrors] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const[allDistrictsStudents,setAllDistrictsStudents]=useState([])
  const[allTalukasStudents,setAllTalukasStudents]=useState([])
  const[allTalukasSchool,setAllTalukasSchool]=useState([])
 const[examForms,setExamForms]=useState([])
const[form_id,setFormId]=useState("")
 const[isDelete,setIsDelete]=useState(false) 
    const[isDeleteModal,setDeleteModal]=useState(false)
const[gender,setGender]=useState("")
const[exam_medium,setExamMedium]=useState("marathi")
const[examFormId,setExamFormId]=useState("")
const [selectedSchool, setSelectedSchool] = useState(null);
const [schoolSelected, setSchoolSelected] = useState(false);
const [isSearching, setIsSearching] = useState(false);
const searchTimerRef = useRef(null);

  const { data: districts } = useGetDistrictQuery();
  const {   
    handleFirstPage,
    handlePageSizeChange,
    handleLastPage,
    sequenceStartIndex,
    page,
    rowsPerPage,
    totalRows,
    setTotalRows,
    setPage,
    setTotalPages,
    totalPages
} = useDataTable();
  const { data, isSuccess, isLoading, error, refetch } = useGetAllExamFormsByAgentsQuery({
    page_number: page,
    page_size: rowsPerPage
   // subAgentValue: "",
    //examNameValue: "",
    //examStandardValue: ""
});
 //const { data, isSuccess, isLoading, error, refetch } = useGetAllExamFormsByAgentsQuery();
useEffect(() => {
  if (isSuccess) {
     // console.log("Exam form data by agents", data);
      setExamForms(data.data);
  }
}, [data, isSuccess]);
  const [SaveExamForm, { data:saveData, isSuccess:saveSuccess, isLoading:saveLoading, isError:saveIsError, error:saveError }] = useSaveExamFormMutation();
  const [EditExamForm, { data:editData, isSuccess:editSuccess, isLoading:editLoading, isError:editIsError, error:editError }] = useEditExamFormMutation();
  
  const [SoftDeleteExamForm, {
          data:deleteData=[],
          isSuccess:deleteIsSuccess,
          isLoading:deleteIsLoading,
          isError:deleteIsError,
          error:deleteError }] = useSoftDeleteExamFormMutation();
 
  const searchSchools = (keyword) => {
    if (!keyword || keyword.length < 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    setIsSearching(true);
    fetch(`${Config.API_URL_LOCAL}exam/searchExamSchools`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ keyword }),
    })
      .then((r) => r.json())
      .then((data) => {
        setSuggestions(data.allSchools || []);
        setShowSuggestions(true);
        setIsSearching(false);
      })
      .catch(() => setIsSearching(false));
  };

  const handleSchoolInputChange = (e) => {
    const val = e.target.value;
    setSchoolName(val);
    setSchoolSelected(false);
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => searchSchools(val), 400);
  };

  const handleSuggestionClick = (suggestion) => {
    setSchoolName(suggestion.school_name);
    setSchoolSelected(true);
    setShowSuggestions(false);
  };

 

  const getTalukaByDistrict = (selectedDistrict) => {
    fetch(`${Config.API_URL_LOCAL}exam/gettalukabydistrict`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ district_id: selectedDistrict }), // Correctly format the body
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json(); // Parse the JSON response
    })
    .then((data) => {
        console.log("response talukas", data);
        setAllTalukasStudents(data.allTalukas)        
    })
    .catch((error) => {
        console.error('Error fetching talukas:', error);
    });
};

const getTalukaByDistrictSchool = (selectedDistrict) => {
  fetch(`${Config.API_URL_LOCAL}exam/gettalukabydistrict`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({ district_id: selectedDistrict }), // Correctly format the body
  })
  .then((response) => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.json(); // Parse the JSON response
  })
  .then((data) => {
      console.log("response talukas", data);
      setAllTalukasSchool(data.allTalukas)        
  })
  .catch((error) => {
      console.error('Error fetching talukas:', error);
  });
};
useEffect(()=>{
  const queryParams = new URLSearchParams(location.search);
  const examParam = queryParams.get('exam');
  // setExamName(examParam)
  // if(examParam=="tse")
  //   {
  //     setExamId("646cab9bde9bdd1eb74a41e8")
  //   }
  //   if(examParam=="shatabdi")
  //     {
  //       setExamId("646cabb1de9bdd1eb74a41ea")
  //     }
  // console.log("examParam",examParam)
},[])

  useEffect(()=>{
    setAllDistrictsStudents(districts?.allDistricts)
   // console.log("districts",districts)
  },[districts])
 const validateForm = () => {
  const newErrors = {};

  if (!exam_name) newErrors.exam_name = "परीक्षा निवडा";
  if (!exam_standard) newErrors.exam_standard = "इयत्ता निवडा";
  if (!first_name) newErrors.first_name = "नाव आवश्यक आहे";
  else if (!MARATHI_REGEX.test(first_name)) newErrors.first_name = "फक्त मराठी अक्षरे लिहा";
  if (!middle_name) newErrors.middle_name = "वडिलांचे नाव आवश्यक आहे";
  else if (!MARATHI_REGEX.test(middle_name)) newErrors.middle_name = "फक्त मराठी अक्षरे लिहा";
  if (!last_name) newErrors.last_name = "आडनाव आवश्यक आहे";
  else if (!MARATHI_REGEX.test(last_name)) newErrors.last_name = "फक्त मराठी अक्षरे लिहा";
  if (!gender) newErrors.gender = "लिंग निवडा";
  if (!mobile_number) newErrors.mobile_number = "मोबाईल क्रमांक आवश्यक आहे";
  else if (!/^[6-9]\d{9}$/.test(mobile_number)) newErrors.mobile_number = "वैध मोबाईल क्रमांक लिहा";
  if (!school_name || !schoolSelected) newErrors.school_name = "यादीतून शाळा निवडणे आवश्यक आहे";

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
  const onSubmit=()=>{
     if (!validateForm()) return;
    setIsSubmitting(true)
    console.log("Gender on submit",gender)
    if(!isUpdate)
    {
      SaveExamForm(
        {
          exam_name,
         // enrollment_date:enrollmentDate,
          first_name:first_name,
          middle_name,
          last_name,
          mobile_number,
          exam_medium,
            exam_standard,
          school_name,
           gender:gender
         // student_district:student_district_name,
         // student_taluka:student_taluka,
        //  student_address,
        
         // center_name,
        //  school_district:school_district_name,
         // school_area,
        //  school_taluka,
        //  school_contact_person,
         

      }
    )

    }
    if(isUpdate)
    {
      EditExamForm(
        {
          examFormId,
          exam_name,
          //enrollment_date:enrollmentDate,
          first_name:first_name,
          middle_name,
          last_name,
          mobile_number,
         // student_district:student_district_name,
         // student_taluka:student_taluka,
         // student_address,
          exam_standard,
          exam_medium,
          school_name,
          //center_name,
         // school_district:school_district_name,
        //  school_area,
        //  school_taluka,
        //  school_contact_person,
          gender:gender
      }
      )

    }
  }
  const clearExamForm=()=>{
    setFirstName("")
    setMiddleName('')
    setLastName('')
    setCenterName("")
    setStudentAddress('')
    setMobileNumber("")
    setSchoolName("")
    setSchoolSelected(false)
    setSuggestions([])
  //  setExamMedium("")
  }
  useEffect(()=>{
    console.log("saveData",saveData)
   
    if(saveSuccess)
       if(saveData.error==true)
    {
      toast.error(saveData.message)
       setIsSubmitting(false)
        clearExamForm()
    }
    else
      {
        setIsSubmitting(false)
        clearExamForm()
        toast.success("form saved successfully")
      }
  },[saveData])
   useEffect(()=>{
    console.log("editData",editData)
    if(editSuccess)
      {
        setIsSubmitting(false)
        setIsUpdate(false)
        setFormId("")
        clearExamForm()
        toast.success("form updated successfully")
      }
  },[editData])

  const handleEdit=(dataRow)=>{
    setExamFormId(dataRow._id)
    setFirstName(dataRow.first_name)
    setMiddleName(dataRow.middle_name)
    setLastName(dataRow.last_name)
    setExamName(dataRow.exam_name)
    setExamMedium(dataRow.exam_medium)
    setExamStandard(dataRow.exam_standard)
    setGender(dataRow.gender)
   // setStudentAddress(dataRow.student_address)
    setMobileNumber(dataRow.mobile_number)
    setSchoolName(dataRow.school_name)
    setSchoolSelected(true)
    setIsUpdate(true)

   // setSchoolContactPerson(dataRow.contact_person_name)
  }
  const handleDelete=(dataRow)=>{
    setDeleteModal(true)
    setFormId(dataRow._id)
  }
  useEffect(() => {
    if(isDelete)
    {
      SoftDeleteExamForm({ examFormId: form_id, user_id: userData?._id });
    }

  }, [isDelete]);
  useEffect(()=>{

    if(deleteIsSuccess)
    {
      console.log("deleteddataProduct",deleteData)

      if(!deleteData.error)
      {
        // setProducts(deleteData.data)
        // setTotalRows(deleteData.totalRows)
        toast.success(deleteData.message)
        setIsDelete(false)
        setDeleteModal(false)


//refetch()
        
      }
      else
      {
        toast.error(deleteData.message)
        setIsDelete(false)
        setDeleteModal(false)

      }
    
    }
      },[deleteData])

      useEffect(() => {
        refetch();
      }, [page]);
    const HomeScreen=()=>{
      return(
        <>
         <
                WarningModal
                setShowWarningModal={setDeleteModal}
                modalTitle={"Delete Product"}
                setIsDelete={setIsDelete}
                showModal={isDeleteModal}
              />
        <ToastContainer/>
        <main id="main" class="main">
<div className='container'>
  <div className="row">
  <div className='col-md-5'>
    <div className='card'>
      <div className="card-body">
      <div className="form-group">
      <label htmlFor="input1">परीक्षा <span className="red-star">*</span></label>
                    <select
                                            value={exam_name}
                                            className="form-control mb-3" 
                                            onChange={(e) => setExamName(e.target.value)}
                                           //onChange={handleDistrictChange}
                                        >
                                            <option value="">Select Exam</option>
                                            
                              {/* <option value="646cab9bde9bdd1eb74a41e8">गुणवत्ता शोध परीक्षा</option>
                              <option value="646cabb1de9bdd1eb74a41ea">शताब्दी शिष्यवृत्ती परीक्षा</option> */}
                               <option value="गुणवत्ता शोध परीक्षा">गुणवत्ता शोध परीक्षा</option>
                              <option value="शताब्दी शिष्यवृत्ती परीक्षा">शताब्दी शिष्यवृत्ती परीक्षा</option>
                                
                                        </select>
                                          {errors.exam_name && <small className="text-danger">{errors.exam_name}</small>}
                                        </div>
                                          <div className="form-group">
                  <label htmlFor="input1">इयत्ता <span className="red-star">*</span></label>
                    <select
                                            value={exam_standard}
                                            className="form-control mb-3" 
                                            onChange={(e) => setExamStandard(e.target.value)}
                                           //onChange={handleDistrictChange}
                                        >
                                            <option value="">Select Standard</option>
                                            {
                          exam_name === "गुणवत्ता शोध परीक्षा" && (
                            <>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="8">8</option>
                            </>
                          )
                        }
                         {
                          exam_name === "शताब्दी शिष्यवृत्ती परीक्षा" && (
                            <>
                              <option value="4">4</option>
                              <option value="7">7</option>
                             
                            </>
                          )
                        }
                                           
                                        </select>
                                          {errors.exam_standard && <small className="text-danger">{errors.exam_standard}</small>}

                                        </div>

                                        
                                            <div className="form-group">
                                              <label htmlFor="input1">माध्यम</label>
                                              <input type="text" className="form-control mb-3" value="मराठी" readOnly disabled style={{ backgroundColor: '#f8f9fa', color: '#495057' }} />
                                            </div>
      {/* <div className="form-group">
                  <label htmlFor="input1">Enrollment Date <span className="red-star">*</span></label>
                  <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="enrollmentDate"
                  value={enrollmentDate}
                  onChange={(e) => setEnrollmentDate(e.target.value)}
                   />
                </div> */}
              
                                        <div className="form-group">
      <label htmlFor="input1">लिंग <span className="red-star">*</span></label>
                    <select
                                            value={gender}
                                            className="form-control mb-3"
                                            onChange={(e) => setGender(e.target.value)}
                                        >
                                            <option value="">Select Gender</option>
                              <option value="कुमार">कुमार </option>
                              <option value="कुमारी">कुमारी </option>
                                        </select>
                                          {errors.gender && <small className="text-danger">{errors.gender}</small>}
                                        </div>

                                        <div className="form-group">
                  <label htmlFor="input1">नाव <span className="red-star">*</span></label>
                  <input type="text"
                  className="form-control mb-3"
                  id="input1"
                  name="first_name"
                  value={first_name}
                  onChange={(e) => setFirstName(marathiOnly(e.target.value))}
                  placeholder="मराठी नाव लिहा"
                   />
                                          {errors.first_name && <small className="text-danger">{errors.first_name}</small>}

                </div>
                <div className="form-group">
                  <label htmlFor="input1">वडिलांचे नाव <span className="red-star">*</span></label>
                  <input type="text"
                  className="form-control mb-3"
                  id="input1"
                  name="middle_name"
                  value={middle_name}
                  onChange={(e) => setMiddleName(marathiOnly(e.target.value))}
                  placeholder="मराठी नाव लिहा"
                   />
                                          {errors.middle_name && <small className="text-danger">{errors.middle_name}</small>}

                </div>
                <div className="form-group">
                  <label htmlFor="input1">आडनाव <span className="red-star">*</span></label>
                  <input type="text"
                  className="form-control mb-3"
                  id="input1"
                  name="last_name"
                  value={last_name}
                  onChange={(e) => setLastName(marathiOnly(e.target.value))}
                  placeholder="मराठी नाव लिहा"
                   />
                                          {errors.last_name && <small className="text-danger">{errors.last_name}</small>}

                </div>
                {/* <div className="form-group">
                  <label>विद्यार्थ्यांचा जिल्हा <span className="red-star">*</span></label>
                    <select
                                            value={student_district_id}
                                            className="form-control mb-3" 
                                           // onChange={(e) => setStudentDistrict(e.target.value)}
                                           onChange={handleDistrictChange}
                                        >
                                            <option value="">Select District</option>
                                            {allDistrictsStudents?.map((eventData) => {
                                                //console.log("eventData", eventData);
                                                return (
                                                    <option key={eventData._id} value={eventData._id}>{eventData.district_name}</option>
                                                );
                                            })}
                                        </select>
                                        </div> */}
                                        {/* <div className="form-group">
                                          <label>विद्यार्थ्यांचा तालुका <span className="red-star">*</span></label>
                    <select
                                            value={student_taluka}
                                            className="form-control mb-3" 
                                            onChange={(e) => setStudentTaluka(e.target.value)}
                                           
                                        >
                                            <option value="">Select Taluka</option>
                                            {allTalukasStudents?.map((eventData) => {
                                              //  console.log("eventData", eventData);
                                                return (
                                                    <option key={eventData._id} value={eventData.taluka_name}>{eventData.taluka_name}</option>
                                                );
                                            })}
                                        </select>
                                        </div> */}
                                        {/* <div className="form-group">
                  <label htmlFor="input1">कायमस्वरूपी निवासी पत्ता <span className="red-star">*</span></label>
                  <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="student_address"
                  value={student_address}
                  onChange={(e) => setStudentAddress(e.target.value)}
                   />
                </div> */}
                <div className="form-group">
                  <label htmlFor="input1">दूरध्वनी क्रमांक <span className="red-star">*</span></label>
                  <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="mobile_number"
                  value={mobile_number}
                  onChange={(e) => setMobileNumber(e.target.value)}
                   />
                                          {errors.mobile_number && <small className="text-danger">{errors.mobile_number}</small>}

                </div>

                {/* <div className="form-group">
                  <label>शाळा क्षेत्र</label>
                    <select
                                            value={school_area}
                                            className="form-control mb-3" 
                                            onChange={(e) => setSchoolArea(e.target.value)}
                                           //onChange={handleDistrictChange}
                                        >
                                            <option value="">शाळा क्षेत्र <span className="red-star">*</span></option>
                                           
                              <option value="शहरी">शहरी</option>
                              <option value="ग्रामीण">ग्रामीण</option>
                             
                                           
                                        </select>
                                        </div> */}
                                        {/* <div className="form-group">
                                        <label htmlFor="input1">शाळेचा जिल्हा <span className="red-star">*</span></label>
                    <select
                                            value={school_district_id}
                                            className="form-control mb-3" 
                                           // onChange={(e) => setStudentDistrict(e.target.value)}
                                           onChange={handleDistrictChangeSchool}
                                        >
                                            <option value="">Select District</option>
                                            {allDistrictsStudents?.map((eventData) => {
                                               // console.log("eventData", eventData);
                                                return (
                                                    <option key={eventData._id} value={eventData._id}>{eventData.district_name}</option>
                                                );
                                            })}
                                        </select>
                                        </div> */}
                                        {/* <div className="form-group">
                                          <label>शाळेचा तालुका <span className="red-star">*</span></label>
                    <select
                                            value={school_taluka}
                                            className="form-control mb-3" 
                                            onChange={(e) => setSchoolTaluka(e.target.value)}
                                           
                                        >
                                            <option value="">Select Taluka</option>
                                            {allTalukasSchool?.map((eventData) => {
                                              //  console.log("eventData", eventData);
                                                return (
                                                    <option key={eventData._id} value={eventData.taluka_name}>{eventData.taluka_name}</option>
                                                );
                                            })}
                                        </select>
                                        </div> */}
                <div className="form-group" style={{ position: 'relative' }}>
                      <label htmlFor="input2">शाळेचे नाव <span className="red-star">*</span></label>
                      <input
                        type="text"
                        className="form-control mb-1"
                        id="input2"
                        name="school_name"
                        placeholder="शाळेचे नाव टाइप करा..."
                        value={school_name}
                        onChange={handleSchoolInputChange}
                        onBlur={() => setTimeout(() => {
                          setShowSuggestions(false);
                          if (!schoolSelected) setSchoolName('');
                        }, 200)}
                        onFocus={() => suggestions.length > 0 && setShowSuggestions(true)}
                        autoComplete="off"
                      />
                      {errors.school_name && <small className="text-danger d-block mb-1">{errors.school_name}</small>}
                      {isSearching && <small className="text-muted">शोधत आहे...</small>}
                      {showSuggestions && suggestions.length > 0 && (
                        <ul className="list-group" style={{ position: 'absolute', zIndex: 999, width: '100%', maxHeight: '200px', overflowY: 'auto' }}>
                          {suggestions.map((suggestion, index) => (
                            <li
                              key={index}
                              className="list-group-item list-group-item-action"
                              onMouseDown={() => handleSuggestionClick(suggestion)}
                              style={{ cursor: 'pointer' }}
                            >
                              {suggestion.school_name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  
                    {/* <div className="form-group">
                  <label htmlFor="input1">केंद्राचे नाव</label>
                  <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="student_address"
                  value={center_name}
                  onChange={(e) => setCenterName(e.target.value)}
                   />
                </div> */}
                {/* <div className="form-group">
                  <label htmlFor="input1">शाळेतील संपर्ककर्त्याचे नाव</label>
                  <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="student_address"
                  value={school_contact_person}
                  onChange={(e) => setSchoolContactPerson(e.target.value)}
                   />
                </div> */}
                <div className='form-group'>
                <button type="submit" 
                className="btn btn-primary"              
                onClick={()=>onSubmit()}
                >
                   {isSumbmiting ? 
                  'Submitting...' : 
                  isUpdate?'Update':
                  'Submit'} 
                 
                </button>

                </div>


                                      

                                       

      </div>
    </div>
  </div>
  <div className='col-md-7'>
    <div className='card'>
      <div className="card-body">
      <table className="bordered-table">
                                    <thead>
                                        <tr>
                                          <th>Action</th>
                                            <th>Index</th>
                                            <th>Exam</th>
                                            <th>Student</th>
                                            <th>Standard</th>
                                             <th>Mobile</th>
                                            {/* <th>Student Address</th>
                                            <th>School Address</th> */}
                                            <th>Form Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {examForms.map((item, index) => (
                                            <tr key={index}>
                                              <td>
                <MdEdit onClick={()=>handleEdit(item)}
                style={{cursor:'pointer'}}/>
              {userData?.role === 'superadmin' && (
                <MdDelete onClick={()=>handleDelete(item)} style={{cursor:'pointer', marginLeft: 6, color: '#dc3545'}}/>
              )}
              </td>
                                                <td>{sequenceStartIndex + index}</td>
                                                <td>
                                                    {item.exam_name + " | " + item.exam_fees + " Rs "}
                                                </td>
                                                <td>
                                                    {item.first_name + " " + item.middle_name + " " + item.last_name+" | "+item.gender+" | "+item.school_name}
                                                </td>
                                                <td>
                                                    {item.exam_standard}{"|" +item.exam_medium}
                                                </td>
                                                 <td>
                                                    {item.mobile_number}
                                                </td>
                                                {/* <td>
                                                    {item.student_address + " | " + item.student_district + " | " + item.student_taluka + " | " + item.mobile_number}
                                                </td>
                                                <td>
                                                    {item.school_name + " | " + item.school_district + " | " + item.school_taluka + " | " + item.school_area}
                                                </td> */}
                                                <td>
                                                    {item.form_created_date + " " + item.form_created_time}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <button onClick={() => setPage(page - 1)} disabled={page === 0}><GrFormPrevious /></button>
                                <button onClick={() => setPage(page + 1)} disabled={page === totalPages - 1}><MdOutlineNavigateNext /></button>
                                <div>
                                    <select value={rowsPerPage} onChange={handlePageSizeChange}>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
      </div>
    </div>
  </div>
  </div>

</div>
        </main>
        </>
      )
      
    }
  return (
    <Template>
        {HomeScreen()}
    </Template>
  )
}

export default Home